import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureSection from './components/FeatureSection';
import AboutSection from './components/AboutSection';
import BlogSection from './components/BlogSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://cssbuy.today';

export default function Home() {
  const { t } = useTranslation();

  const siteName = 'cssbuy.today';
  const pageTitle = 'CSSBuy Spreadsheet 2026 – Melhor Guia Completo em Português | cssbuy.today';
  const pageDesc = 'Guia completo CSSBuy Spreadsheet 2026 em português. Aprenda como usar, compare agentes de shopping, descubra as melhores lojas Taobao e Weidian. Tabelas atualizadas, dicas de segurança e economia.';

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteName,
    url: SITE_URL,
    description: pageDesc,
    sameAs: [
      'https://kaspreadsheet.com/',
    ],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteName,
    url: SITE_URL,
    inLanguage: 'pt',
    description: pageDesc,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/?s={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: pageTitle,
    description: pageDesc,
    url: SITE_URL,
    inLanguage: 'pt',
    isPartOf: {
      '@type': 'WebSite',
      name: siteName,
      url: SITE_URL,
    },
    about: {
      '@type': 'Thing',
      name: 'CSSBuy Spreadsheet',
    },
  };

  const schemaScript = JSON.stringify([organizationSchema, websiteSchema, webpageSchema]);

  return (
    <>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <meta name="keywords" content="CSSBuy spreadsheet, CSSBuy spreadsheet 2026, guia CSSBuy português, agente shopping, Taobao, Weidian, CSSBuy guia completo, melhor spreadsheet CSSBuy" />
      <link rel="canonical" href={SITE_URL} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:url" content={SITE_URL} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="CSSBuy Spreadsheet 2026 – Melhor Guia em Português" />
      <meta name="twitter:description" content="Guia completo CSSBuy Spreadsheet. Compare agentes, encontre as melhores lojas e aprenda a economizar." />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schemaScript }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />

          <CategoryGrid />

          <FeatureSection />

          <AboutSection />

          <BlogSection />

          <TestimonialSection />

          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
}